var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoTabletPc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico-tabletPC",
    transform: "translate(-2340 -10298)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_103",
    "data-name": "Rectangle 103",
    width: 40,
    height: 40,
    transform: "translate(2340 10298)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ico_tabletpc",
    transform: "translate(2336.693 10292.328)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_507",
    "data-name": "Groupe 507",
    transform: "translate(7.264 8.672)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4",
    "data-name": "Ellipse 4",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    transform: "translate(12.931 3.704)",
    fill: "#646464"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_57",
    "data-name": "Trac\\xE9 57",
    d: "M33.824,8.916a2.954,2.954,0,0,0-1.51-.225L11.4,11.1a2.978,2.978,0,0,0-2.61,3.32l1.37,11.92a2.992,2.992,0,0,0,1.79,2.415,2.954,2.954,0,0,0,1.51.225l20.91-2.4a2.978,2.978,0,0,0,2.61-3.32l-1.37-11.92a2.992,2.992,0,0,0-1.79-2.415Zm1.67,14.51a1.489,1.489,0,0,1-1.295,1.66l-20.91,2.4a1.482,1.482,0,0,1-1.635-1.32l-1.37-11.92a1.489,1.489,0,0,1,1.295-1.66l20.91-2.4a1.482,1.482,0,0,1,1.635,1.32l1.37,11.92Z",
    transform: "translate(-8.768 -8.672)",
    fill: "#646464"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_508",
    "data-name": "Groupe 508",
    transform: "translate(5.76 30.836)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_58",
    "data-name": "Trac\\xE9 58",
    d: "M33.4,54.5a4.53,4.53,0,0,1,1.16.15,2.3,2.3,0,0,1,1.055.52l2.865,7.32a.46.46,0,0,0,.015.045.932.932,0,0,1-.35.24A3.114,3.114,0,0,1,36.915,63H8.845a3.132,3.132,0,0,1-1.235-.225.932.932,0,0,1-.35-.24.115.115,0,0,1,.015-.045l2.865-7.32a2.3,2.3,0,0,1,1.055-.52,4.5,4.5,0,0,1,1.16-.15H33.4m0-1.5H12.355a6.2,6.2,0,0,0-1.545.2,2.971,2.971,0,0,0-2.055,1.39L5.88,61.94A1.683,1.683,0,0,0,7,64.14a4.528,4.528,0,0,0,1.845.355H36.915a4.528,4.528,0,0,0,1.845-.355,1.688,1.688,0,0,0,1.125-2.2L37.01,54.59a2.971,2.971,0,0,0-2.055-1.39A5.973,5.973,0,0,0,33.41,53h0Z",
    transform: "translate(-5.76 -53)",
    fill: "#646464"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_59",
    "data-name": "Trac\\xE9 59",
    d: "M39.251,66.5h-11a.746.746,0,0,1-.6-.3.76.76,0,0,1-.12-.66l.89-3a.746.746,0,0,1,.72-.535h9.22a.756.756,0,0,1,.72.535l.89,3a.745.745,0,0,1-.12.66A.753.753,0,0,1,39.251,66.5ZM29.256,65h8.99L37.8,63.5H29.7Z",
    transform: "translate(-16.631 -57.505)",
    fill: "#646464"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_60",
    "data-name": "Trac\\xE9 60",
    d: "M71.5,40.775,69.275,38.55,67.05,40.775h1.475v3a1.006,1.006,0,0,1-.675.945,1.707,1.707,0,0,0,.425.055,1.369,1.369,0,0,0,.25-.02,1.751,1.751,0,0,0,1.5-1.73v-2.25Z",
    transform: "translate(-30.645 -14.939)",
    fill: "#646464"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoTabletPc);
export default __webpack_public_path__ + "static/media/ico-tabletPC.db1a40274292c46b8c9c3fbd8f54ef44.svg";
export { ForwardRef as ReactComponent };